import LandingPage from "@/components/LandingPage";

const internal = [
  { label: "Sport-Content", to: "/sport-content" },
  { label: "Eventfilm", to: "/eventfilm" },
  { label: "Videoproduktion Bochum", to: "/videoproduktion-bochum" },
  { label: "Videoproduktion Ruhrgebiet", to: "/videoproduktion-ruhrgebiet" },
  { label: "Alle Leistungen", to: "/leistungen" },
];

const MotorsportVideoproduktion = () => (
  <LandingPage
    path="/motorsport-videoproduktion"
    metaTitle="Motorsport Videoproduktion Bochum & NRW | 4FaceMedia"
    metaDescription="Cinematic Motorsport-Videoproduktion am Nürburgring & deutschlandweit. Teamfilme, Driver-Stories, Rennwochenenden & Sponsorencontent. Jetzt anfragen."
    eyebrow="Motorsport · Videoproduktion · Bochum · NRW"
    h1={
      <>
        Motorsport, der <span className="text-gradient">unter die Haut geht</span>.
      </>
    }
    intro="Wir produzieren cinematic Motorsport-Content für Teams, Fahrer & Sponsoren – von der Boxengasse bis zum Highlight-Reel. Direkt an der Strecke, technisch präzise, emotional erzählt."
    serviceName="Motorsport Videoproduktion"
    serviceDescription="Cinematic Videoproduktion für Motorsport-Teams, Rennfahrer, Veranstalter & Sponsoren. Onboard-Sequenzen, Driver-Stories, Aftermovies & Sponsorencontent."
    areaServed={["Bochum", "Ruhrgebiet", "Nürburgring", "Nordrhein-Westfalen", "Deutschland"]}
    bullets={[
      { title: "Rennwochenenden begleiten", text: "Vom Freien Training bis zum Podium – wir sind mit euch in der Box, an der Strecke und im Fahrerlager. Inkl. Drohnenaufnahmen und Onboard-Material." },
      { title: "Driver- & Teamstories", text: "Authentische Porträts, die Persönlichkeit zeigen und Sponsoren überzeugen. Dokumentarisch, nicht gestellt." },
      { title: "Sponsoren-Content", text: "Kurze, plattformgerechte Cuts für Instagram, TikTok & LinkedIn – damit jeder Sponsor seine Sichtbarkeit messbar zurückbekommt." },
      { title: "Aftermovies in Kinoqualität", text: "Cinematic Aftermovies, die Adrenalin, Atmosphäre und Speed digital erlebbar machen." },
      { title: "Technische Präzision", text: "Wir kennen die Strecke, kennen die Regeln – und wissen, wo der entscheidende Frame entsteht." },
      { title: "Schnelle Auslieferung", text: "Social-Cuts noch am Renntag, Hauptfilm in vereinbarter Deadline. Verlässlich planbar." },
    ]}
    faqs={[
      { q: "Begleitet ihr auch nationale & internationale Rennserien?", a: "Ja. Wir produzieren regelmäßig am Nürburgring sowie auf Strecken in ganz Deutschland und im benachbarten Ausland. Reisetage und Logistik werden im Angebot transparent ausgewiesen." },
      { q: "Bekomme ich Social-Cuts noch am Renntag?", a: "In den meisten Paketen ja. Kurze, plattformgerechte Highlight-Clips liefern wir in der Regel noch am selben Tag oder am Folgetag." },
      { q: "Dürft ihr in der Boxengasse & im Fahrerlager filmen?", a: "Wir kümmern uns auf Wunsch um Akkreditierungen und stimmen uns mit Veranstaltern, Teams und Streckenposten ab. Sicherheit und Reglement haben Priorität." },
      { q: "Was kostet eine Motorsport-Videoproduktion?", a: "Das hängt von Renndauer, Crew-Größe, Drohne, Onboard-Equipment und Liefermenge ab. Wir erstellen ein transparentes Angebot nach einem kurzen Briefing-Call." },
      { q: "Liefert ihr Material auch im Hochformat für Sponsoren?", a: "Ja. Alle Cuts liefern wir auf Wunsch zusätzlich im 9:16-Format für Instagram Reels, TikTok und Shorts." },
    ]}
    internalLinks={internal}
  />
);

export default MotorsportVideoproduktion;
